import type { SVGProps } from "react";

interface LogoIconProps extends SVGProps<SVGSVGElement> {
  size?: number;
}

export function LogoIcon({ size = 32, ...props }: LogoIconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect width="32" height="32" rx="8" fill="white" fillOpacity="0.1" />
      <path
        d="M16 8L22 12V20L16 24L10 20V12L16 8Z"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
